export const headItems = ['ID', 'Company name', 'Country', 'Actions']

export const COMPANY_ID_INDEX = 0
export const COMPANY_NAME_INDEX = 1
export const COUNTRY_INDEX = 2
